export default {
  chat: {
    recipients: "Empfänger",
    subject: "Betreff",
    message: "Nachricht",
    report: "Melden",
    report_confirm: "Möchten Sie diese Nachricht wirklich melden?",
    report_success: "Vielen Dank für Ihre Meldung!",
    message_success: "Ihre Nachricht wurde erfolgreich gesendet!",
    signaled: "Sie haben einen Missbrauch gemeldet",
    message_notifs: "neue Nachrichten",
    message_notif: "neue Nachricht",
    message_error: "Ups, beim Senden ist ein Fehler aufgetreten",
    create_message: "Neue Nachricht",
    moderation: "Moderation",
    to: "An",
    choose_recipients: "Empfänger auswählen",
    email_answer_notif: "E-Mail-Benachrichtigung bei Antworten erhalten",
    email_recipient_notif: "Empfänger per E-Mail benachrichtigen",
    archived_messages: "Archivierte Nachrichten anzeigen",
    archived_messages_list: "Archivierte Nachrichten",
    receipt_messages: "Empfangene Nachrichten anzeigen",
    sending: "Wird gesendet...",
    archive_confirm: "Möchten Sie diese Nachricht wirklich archivieren?",
    unarchive_confirm: "Möchten Sie diese Nachricht wirklich dearchivieren?",
    delete_title: "Gespräch löschen",
    delete_confirm: "Möchten Sie dieses Gespräch wirklich löschen?",
    delete_success: "Gespräch erfolgreich gelöscht!",
    placeholder: "Geben Sie Ihre Nachricht ein...",
    placeholder_subject: "Betreff...",
    select_message: "Klicken Sie auf ein Gespräch",
  },
};
